// importing images
import affiliate_black from './images/affiliate_black.svg';
import affiliate_green from './images/affiliate_green.svg';
import ask_black from './images/ask_black.svg';
import ask_green from './images/ask_green.svg';
import busi_acc_black from './images/busi_acc_black.svg';
import busi_acc_green from './images/busi_acc_green.svg';
import delivery_black from './images/delivery_black.svg';
import delivery_green from './images/delivery_green.svg';
import family_card_black from './images/family_card_black.svg';
import family_card_green from './images/family_card_green.svg';
import order_black from './images/order_black.svg';
import order_green from './images/order_green.svg';
import payments_black from './images/payments_black.svg';
import payments_green from './images/payments_green.svg';
import supplier_black from './images/supplier_black.svg';
import supplier_green from './images/supplier_green.svg';
import user_acc_black from './images/user_acc_black.svg';
import user_acc_green from './images/user_acc_green.svg';

export const faqData = [
  {
    id: 1,
    name: 'Orders',
    inactive_image: order_black,
    active_image: order_green,
    questions: [
      {
        id: 1,
        question: 'What is Desi Fresh Shop?',
        answer:
          'Desi Fresh is a fresh approach to the halal grocery shopping. We offer 100% authentic halal for a delicious, nutritious, and hygienic experience. Our promise to you is outstanding customer experience, and our promise of Zakat means we give back to the poor with every purchase you make. Desi Fresh employs a unique traceability system that guarantees transparency, quality, and authenticity for every product on our shelves. We are Desi Fresh, the halal food company made for you.',
      },
      {
        id: 2,
        question: 'Are you a halal certified shop?',
        answer:
          'Yes, and we couldn’t be prouder! Go Halal is certified as a Trusted Halal Shop by Pro Halal Certification. We are honored to have this accreditation—this is the first time ever in retail store history! Go Halal is incredibly thankful to our Quality Assurance team and the Pro Halal team to incorporate the new traceability system in order to bestow complete transparency and prevent halal fraud.',
      },
      {
        id: 3,
        question: 'What are standard shipping Policies?',
        answer:
          'Delivery is Monday to Saturday between 11:OO Hrs to 20:00 Hrs local time. If you are not home to accept delivery, a delivery notification card with further details will be issued. In some cases, e,g. if you choose contact less delivery, the delivery may be left at your doorsteps. Please not for larger orders, may require your presence at the time of delivery.',
      },
      {
        id: 4,
        question: 'Are you an exclusive 100% halal shop?',
        answer:
          'Yes, we pledge to be your 100% halal grocer. Since we were just recently founded, we are currently suppling 100% halal meat, milk, and animal products—but our our goal in the near future is to provide an entire supermarket’s worth of 100% halal products.',
      },
      {
        id: 5,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 6,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 7,
        question: 'Why should we buy from Go Halal?',
        answer:
          'At Go Halal, we believe in doing things the right way at every step of the way: we care about you and your family; we care about authenticity and transparency; and we care about the less fortunate by donating proceeds to the poor with every purchase that you make. Healthy food for a happier, healthier community. We care about giving back while giving you and your family exactly what you want, need, and deserve. We are Go Halal, your 100% trusted halal and a do good grocer.',
      },
      {
        id: 8,
        question: 'Are there any rewards and offers from Go Halal?',
        answer:
          'Sign up to our newsletter to receive promotions, special offers, and updates. We are also launching a Go Halal Family Card that allows you to get special offers and discounts on a subscription service—in addition to connecting with our community and receiving alerts about cherished festivities and special events',
      },
      {
        id: 9,
        question: 'What is Go Halal Affliate?',
        answer:
          'Care about halal as much as we do? Want to earn money for our shared passion? With the Go Halal Affiliate program, you can help us build us reaching each new customer who shops at our store! for additioanl details, please read affliate page or contact us here.',
      },
      {
        id: 10,
        question: 'How can I become a Go Halal supplier?',
        answer:
          'We would love to do business with anyone who demands high quality food standards, sustainable relationships, and superb customer satisfaction. If you are committed to moving the wheel of our engine with our shared values of quality, authenticity, and halal, please send us your information on our Contact Us page.',
      },
    ],
  },
  {
    id: 2,
    name: 'Payments',
    inactive_image: payments_black,
    active_image: payments_green,
    questions: [
      {
        id: 8,
        question: 'Are there any rewards and offers from Go Halal?',
        answer:
          'Sign up to our newsletter to receive promotions, special offers, and updates. We are also launching a Go Halal Family Card that allows you to get special offers and discounts on a subscription service—in addition to connecting with our community and receiving alerts about cherished festivities and special events',
      },
      {
        id: 9,
        question: 'What is Go Halal Affliate?',
        answer:
          'Care about halal as much as we do? Want to earn money for our shared passion? With the Go Halal Affiliate program, you can help us build us reaching each new customer who shops at our store! for additioanl details, please read affliate page or contact us here.',
      },
      {
        id: 10,
        question: 'How can I become a Go Halal supplier?',
        answer:
          'We would love to do business with anyone who demands high quality food standards, sustainable relationships, and superb customer satisfaction. If you are committed to moving the wheel of our engine with our shared values of quality, authenticity, and halal, please send us your information on our Contact Us page.',
      },
    ],
  },
  {
    id: 3,
    name: 'Delivery',
    inactive_image: delivery_black,
    active_image: delivery_green,
    questions: [
      {
        id: 4,
        question: 'Are you an exclusive 100% halal shop?',
        answer:
          'Yes, we pledge to be your 100% halal grocer. Since we were just recently founded, we are currently suppling 100% halal meat, milk, and animal products—but our our goal in the near future is to provide an entire supermarket’s worth of 100% halal products.',
      },
      {
        id: 5,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 6,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 7,
        question: 'Why should we buy from Go Halal?',
        answer:
          'At Go Halal, we believe in doing things the right way at every step of the way: we care about you and your family; we care about authenticity and transparency; and we care about the less fortunate by donating proceeds to the poor with every purchase that you make. Healthy food for a happier, healthier community. We care about giving back while giving you and your family exactly what you want, need, and deserve. We are Go Halal, your 100% trusted halal and a do good grocer.',
      },
    ],
  },
  {
    id: 4,
    name: 'User Account',
    inactive_image: user_acc_black,
    active_image: user_acc_green,
    questions: [
      {
        id: 6,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 7,
        question: 'Why should we buy from Go Halal?',
        answer:
          'At Go Halal, we believe in doing things the right way at every step of the way: we care about you and your family; we care about authenticity and transparency; and we care about the less fortunate by donating proceeds to the poor with every purchase that you make. Healthy food for a happier, healthier community. We care about giving back while giving you and your family exactly what you want, need, and deserve. We are Go Halal, your 100% trusted halal and a do good grocer.',
      },
      {
        id: 8,
        question: 'Are there any rewards and offers from Go Halal?',
        answer:
          'Sign up to our newsletter to receive promotions, special offers, and updates. We are also launching a Go Halal Family Card that allows you to get special offers and discounts on a subscription service—in addition to connecting with our community and receiving alerts about cherished festivities and special events',
      },
      {
        id: 9,
        question: 'What is Go Halal Affliate?',
        answer:
          'Care about halal as much as we do? Want to earn money for our shared passion? With the Go Halal Affiliate program, you can help us build us reaching each new customer who shops at our store! for additioanl details, please read affliate page or contact us here.',
      },
    ],
  },
  {
    id: 5,
    name: 'Business Account',
    inactive_image: busi_acc_black,
    active_image: busi_acc_green,
    questions: [
      {
        id: 2,
        question: 'Are you a halal certified shop?',
        answer:
          'Yes, and we couldn’t be prouder! Go Halal is certified as a Trusted Halal Shop by Pro Halal Certification. We are honored to have this accreditation—this is the first time ever in retail store history! Go Halal is incredibly thankful to our Quality Assurance team and the Pro Halal team to incorporate the new traceability system in order to bestow complete transparency and prevent halal fraud.',
      },
      {
        id: 3,
        question: 'What are standard shipping Policies?',
        answer:
          'Delivery is Monday to Saturday between 11:OO Hrs to 20:00 Hrs local time. If you are not home to accept delivery, a delivery notification card with further details will be issued. In some cases, e,g. if you choose contact less delivery, the delivery may be left at your doorsteps. Please not for larger orders, may require your presence at the time of delivery.',
      },
      {
        id: 4,
        question: 'Are you an exclusive 100% halal shop?',
        answer:
          'Yes, we pledge to be your 100% halal grocer. Since we were just recently founded, we are currently suppling 100% halal meat, milk, and animal products—but our our goal in the near future is to provide an entire supermarket’s worth of 100% halal products.',
      },
    ],
  },
  {
    id: 6,
    name: 'Desi Family card',
    inactive_image: family_card_black,
    active_image: family_card_green,
    questions: [
      {
        id: 6,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 7,
        question: 'Why should we buy from Go Halal?',
        answer:
          'At Go Halal, we believe in doing things the right way at every step of the way: we care about you and your family; we care about authenticity and transparency; and we care about the less fortunate by donating proceeds to the poor with every purchase that you make. Healthy food for a happier, healthier community. We care about giving back while giving you and your family exactly what you want, need, and deserve. We are Go Halal, your 100% trusted halal and a do good grocer.',
      },
      {
        id: 8,
        question: 'Are there any rewards and offers from Go Halal?',
        answer:
          'Sign up to our newsletter to receive promotions, special offers, and updates. We are also launching a Go Halal Family Card that allows you to get special offers and discounts on a subscription service—in addition to connecting with our community and receiving alerts about cherished festivities and special events',
      },
      {
        id: 9,
        question: 'What is Go Halal Affliate?',
        answer:
          'Care about halal as much as we do? Want to earn money for our shared passion? With the Go Halal Affiliate program, you can help us build us reaching each new customer who shops at our store! for additioanl details, please read affliate page or contact us here.',
      },
    ],
  },
  {
    id: 7,
    name: 'Affiliate',
    inactive_image: affiliate_black,
    active_image: affiliate_green,
    questions: [
      {
        id: 4,
        question: 'Are you an exclusive 100% halal shop?',
        answer:
          'Yes, we pledge to be your 100% halal grocer. Since we were just recently founded, we are currently suppling 100% halal meat, milk, and animal products—but our our goal in the near future is to provide an entire supermarket’s worth of 100% halal products.',
      },
      {
        id: 5,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 6,
        question: 'Do you have home delivery options?',
        answer:
          'Yes! Since Go Halal is a brand new concept, we are currently operating 100% online and offering express delivery for Munich within the same day for just 1.95 Euros so long as the minimum purchase amount is met. Standard delivery is free within an average delivery time of 24 hours at a purchase order of 35 Euros. For better experience, Go Halal offers multiple delivery options for your convenience.',
      },
      {
        id: 7,
        question: 'Why should we buy from Go Halal?',
        answer:
          'At Go Halal, we believe in doing things the right way at every step of the way: we care about you and your family; we care about authenticity and transparency; and we care about the less fortunate by donating proceeds to the poor with every purchase that you make. Healthy food for a happier, healthier community. We care about giving back while giving you and your family exactly what you want, need, and deserve. We are Go Halal, your 100% trusted halal and a do good grocer.',
      },
    ],
  },
  {
    id: 8,
    name: 'Suppliers',
    inactive_image: supplier_black,
    active_image: supplier_green,
    questions: [
      {
        id: 2,
        question: 'Are you a halal certified shop?',
        answer:
          'Yes, and we couldn’t be prouder! Go Halal is certified as a Trusted Halal Shop by Pro Halal Certification. We are honored to have this accreditation—this is the first time ever in retail store history! Go Halal is incredibly thankful to our Quality Assurance team and the Pro Halal team to incorporate the new traceability system in order to bestow complete transparency and prevent halal fraud.',
      },
      {
        id: 3,
        question: 'What are standard shipping Policies?',
        answer:
          'Delivery is Monday to Saturday between 11:OO Hrs to 20:00 Hrs local time. If you are not home to accept delivery, a delivery notification card with further details will be issued. In some cases, e,g. if you choose contact less delivery, the delivery may be left at your doorsteps. Please not for larger orders, may require your presence at the time of delivery.',
      },
      {
        id: 4,
        question: 'Are you an exclusive 100% halal shop?',
        answer:
          'Yes, we pledge to be your 100% halal grocer. Since we were just recently founded, we are currently suppling 100% halal meat, milk, and animal products—but our our goal in the near future is to provide an entire supermarket’s worth of 100% halal products.',
      },
    ],
  },
  {
    id: 9,
    name: 'Ask a question',
    inactive_image: ask_black,
    active_image: ask_green,
    questions: [
      {
        id: 4,
        question: 'I don’t see my question here. How can I get in touch?',
        answer:
          'Don’t worry, we are here to help! Please contact us via available channels and we will get back to you as soon as possible.',
      },
    ],
  },
];
